import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import { CustomTable } from "src/component";
import { useQuery } from "@tanstack/react-query";
import { getAllCustomers } from "src/services/api";
import { Link, useSearchParams } from "react-router-dom";
import { formatCustomDate } from "src/utils/functions";
import CustomSearch from "src/component/CustomInput/CustomSearch";

const Customers = () => {
  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page")) || 1;
  const perPage = parseInt(searchParams.get("per_page")) || 10;

  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState(null);

  const { data } = useQuery({
    queryKey: ["users", searchResults, page, perPage],
    queryFn: () =>
      getAllCustomers({
        search: searchResults,
        page,
        limit: perPage,
      }),
    suspense: true,
  });

  const columns = [
    {
      name: "S/N",
      cell: (_, i) => i + 1,
      width: "5%",
    },
    {
      name: "Fullname",
      cell: (row) => <div className="capitalize">{row?.fullName}</div>,
    },
    {
      name: "Email",
      cell: (row) => row?.email,
    },
    {
      name: "Date Requested",
      cell: (row) => (
        <div className="capitalize">{formatCustomDate(row?.last_inquiry_at)}</div>
      ),
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="flex items-center justify-start gap-[2rem]">
          <Link
            to={"/admin/customers/" + row?.id}
            className="flex items-center justify-start my-1 gap-[.5rem] rounded-[1.2rem] text-[1.4rem]  font-normal cursor-pointer hover:text-defaultPrimary"
          >
            <FiEye size="1.6rem" />
            View Details
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex items-center justify-between mb-[3rem]">
        <p className="text-[2.5rem] font-medium text-defaultPrimary">
          Customers
        </p>
      </div>
      <div className="flex justify-start md:justify-end items-center gap-x-[1rem] flex-wrap mb-[2rem]">
        <div className="">
          <CustomSearch
            name="name"
            placeholder="Search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            validate={false}
            formType="fill"
          />
        </div>
        <button
          className="bg-lightPrimary py-[1rem] px-[1.8rem] text-defaultPrimary text-[1.5rem] rounded-lg flex items-center gap-2"
          onClick={() => {
            setSearchResults(searchValue);
          }}
        >
          Search
        </button>
        {searchResults && (
          <button
            className="bg-defaultPrimary py-[1rem] px-[1.8rem] text-white text-[1.5rem] rounded-lg flex items-center gap-2"
            onClick={() => {
              setSearchValue("");
              setSearchResults(null);
            }}
          >
            Reset
          </button>
        )}
      </div>

      <div>
        <CustomTable
          columns={columns}
          data={data?.data?.records}
          paginationTotalRows={data?.data?.pagination?.total}
          paginationPerPage={perPage}
        />
      </div>
    </>
  );
};

export default Customers;
